import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';

export const imageSlider = {
    init() {
        return new Swiper('.listingSwiper', {
            modules: [Navigation, Pagination],
            loop: true,
            lazy: true,
            lazyPreloadPrevNext: 2,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                addIcons: false,
            },
        });
    },
};
